import { useFormContext } from "react-hook-form";
import Button from "@mui/material/Button";
import { Card, CardContent, CardHeader, Grid } from "@mui/material";
import {
  Adrese,
  DrzavaOperatera,
  Identifikatori,
  NazivOperatera,
  UpravljanjePodacimaElektronickeAdrese,
} from "../../../index";
import { TIP_INFO_PORUKE } from "../../../../enums";
import { Context } from "../../../../context";
import axios from "axios";
import { useContext } from "react";

const Index = ({ formRef }: any) => {
  const { setValue, getValues, handleSubmit, setError } = useFormContext();
  const noviOperater = getValues("noviOperater");
  const ostaliOperateri = getValues("ostaliOperateri");
  const [{ token }] = useContext(Context);

  if (!noviOperater) return null;

  const odustani = () => {
    setValue("noviOperater", null);
  };

  const dodaj = async () => {
    const noviOperater = getValues("noviOperater");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/operateri/ostali-operateri`,
        {
          ...noviOperater,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        setValue("infoPoruka", response.data.message);
        setValue("tipInfoPoruke", TIP_INFO_PORUKE.SUCCESS);
        setValue("ostaliOperateri", [
          ...ostaliOperateri,
          getValues("noviOperater"),
        ]);
        setValue("noviOperater", null);
      }
    } catch (error: any) {
      const { status } = error.response;
      if (status === 400) {
        if (error.response.data.errors) {
          error.response.data.errors.forEach((error: any) =>
            setError(`noviOperater.${error.fieldName}`, {
              message: error.error,
            })
          );
        }
      }
    }
  };

  return (
    <Card variant={"outlined"} sx={{ mt: 3, position: "relative" }}>
      <CardHeader
        title={"Dodaj novog operatera (Add new operator)"}
        titleTypographyProps={{ variant: "h6" }}
      />
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <NazivOperatera nazivPolja={`noviOperater.naziv.naziv`} />
          </Grid>
          <Grid item xs={12}>
            <DrzavaOperatera
              nazivOdjeljka={`noviOperater.drzava.oznaka`}
              nazivOdjeljkaEuSifra={`noviOperater.drzava.euSifra`}
            />
          </Grid>
        </Grid>
        <Identifikatori nazivPolja={`noviOperater.identifikatori`} />
        <Adrese nazivPolja={`noviOperater.adrese`} />
        <UpravljanjePodacimaElektronickeAdrese
          nazivPolja={`noviOperater.elektronickeAdrese`}
        />
        <Grid container justifyContent={"flex-end"} sx={{ mt: 3 }}>
          <Button
            type={"button"}
            variant={"contained"}
            color={"error"}
            sx={{ mr: 1 }}
            onClick={odustani}
          >
            Odustani (Cancel)
          </Button>
          <Button variant={"contained"} type={"button"} onClick={dodaj}>
            Dodaj
          </Button>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default Index;
